import { Component } from '@angular/core';

@Component({
    selector: 'app-isentropic-flow',
    templateUrl: './isentropic-flow.component.html',
    styleUrl: './isentropic-flow.component.scss',
    standalone: false
})
export class IsentropicFlowComponent {

}
